const defaultColors = ['#ffa94d', '#ffd43b', '#a9e34b', '#da77f2', '#4dabf7', '#9775fa', '#ff8787', '#38d9a9']

export default function generateColorsForChart(columns) {
  return columns.reduce((obj, el, ind) => {
    obj[el.country_name] = defaultColors[ind]
    return obj
  }, {})
}
